export class BulkActionError extends Error {}

export class AddBannersError {
  constructor() {
    this.errors = []
  }
  add(fileName, exception) {
    this.errors.push({
      fileName,
      exception,
    })
  }
  isEmpty() {
    return this.errors.length === 0
  }
  getMessageArray() {
    return this.errors.map(error => {
      return `${error.fileName}: ${error.exception.message}`
    })
  }
}

// 画像サイズがオーバーした時のエラー
export class OverSizeImageError extends Error {
  constructor(message) {
    super()
    this.name = 'CustomError'
    this.message = message
  }
}

// 圧縮に失敗した時のエラー
export class CannotCompressImageError extends Error {
  constructor(message) {
    super()
    this.name = 'CannotCompressImageError'
    this.message = message
  }
}
